export const FORMAT_OPTIONS = [
    { value: 'NARRATIVE', label: 'Narrative' },
    { value: 'BULLETED', label: 'Bulleted' },
] as const;

export const LENGTH_OPTIONS = [
    { value: 'CONCISE', label: 'Concise' },
    { value: 'STANDARD', label: 'Standard' },
] as const;

export const IDENTIFIER_OPTIONS = [
    { value: 'CLIENT', label: 'Client' },
    { value: 'PATIENT', label: 'Patient' },
] as const;

export const TEMPLATE_OPTIONS = [
    { value: 'NESSO', label: 'Nesso SURE' },
    { value: 'SOAP', label: 'SOAP' },
] as const;

export const MIN_APPROACHES = 1;
export const MAX_APPROACHES = 12;

export const DEFAULT_ERROR_MESSAGE = 'Unable to update notes preferences. Try again.';
